import { createSlice } from "@reduxjs/toolkit";
import { GetAllPriceList, GetAllServicePriceList } from "./PriceApi";

const PriceSlice = createSlice({
  name: "price",
  initialState: {
    priceListData: [],
    individualData: null,
    excelData: [],
    validationErrors: [],
    tableData: [],
    inValidData: [],
    duplicateRows: [],
    isExcelValid: false,
    activeStep: 0,
    importStatus: "idle",
    priceFilters: {
      payer: "",
      nphies_code: "",
      provider_code: "",
      branch: "",
      active: false,
    },
  },
  reducers: {
    setExcelData: (state, action) => {
      state.excelData = action.payload;
    },
    setValidationErrors: (state, action) => {
      state.validationErrors = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setDuplicateRows: (state, action) => {
      state.duplicateRows = action.payload;
    },
    updateDuplicateRow: (state, action) => {
      const { rowNum, updatedData } = action.payload;
      state.duplicateRows = state.duplicateRows.map((row) =>
        row.rowNum === rowNum ? { ...row, ...updatedData } : row
      );
    },
    deleteInvalid: (state, action) => {
      const rowNum = action.payload;
      state.inValidData = state.inValidData.filter((row) => row.id !== rowNum);
    },
    setIsExcelValid: (state, action) => {
      state.isExcelValid = action.payload;
    },
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    deleteRow: (state, action) => {
      const rowNumToDelete = action.payload;
      state.tableData = state.tableData.filter(
        (row) => row.rowNum !== rowNumToDelete
      );
      state.inValidData = state.inValidData.filter(
        (row) => row.rowNum !== rowNumToDelete
      );
    },
    setInvalidData: (state, action) => {
      state.inValidData = action.payload;

      // Update tableData with status = "Invalid" for matching rows
      action.payload?.forEach((invalidItem) => {
        const index = state.tableData.findIndex(
          (row) => row.rowNum === invalidItem.rowNum
        );
        if (index !== -1) {
          state.tableData[index].status = "Invalid"; // 🔥 You can now access this in UI
        }
      });
    },

    updateRowData: (state, action) => {
      const { rowNum, updatedData } = action.payload;
      state.tableData = state.tableData.map((row) =>
        row.rowNum === rowNum ? { ...row, ...updatedData } : row
      );
    },
    updateRowStatus: (state, action) => {
      const { rowNum, isValid, error } = action.payload;
      state.tableData = state.tableData.map((row) => {
        if (row.rowNum === rowNum) {
          const errors = Array.isArray(row.errors)
            ? [...row.errors, error]
            : [error];

          return {
            ...row,
            isValid,
            errors,
          };
        }
        return row;
      });
    },

    resetImportState: (state) => {
      state.excelData = [];
      state.validationErrors = [];
      state.tableData = [];
      state.isExcelValid = false;
      state.importStatus = "idle";
      state.activeStep = 0;
    },
    startImport: (state) => {
      state.importStatus = "loading";
    },
    importSuccess: (state) => {
      state.importStatus = "succeeded";
    },
    importFailed: (state, action) => {
      state.importStatus = "failed";
      state.error = action.payload;
    },
    handlePriceFilter: (state, action) => {
      state.priceFilters[action?.payload?.check] = action?.payload?.value;
    },
    handlePriceReset: (state, _) => {
      state.priceFilters = {
        payer: "",
        nphies_code: "",
        provider_code: "",
        branch: "",
        active: false,
      };
    },
    setIndividualData: (state, action) => {
      state.individualData = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPriceList.fulfilled, (state, action) => {
        state.priceListData = action.payload?.data?.prdtserv_details;
      })
      .addCase(GetAllServicePriceList.fulfilled, (state, action) => {
        state.priceListData = action.payload?.data?.prdtserv_details;
      });
  },
});

export const {
  handlePriceFilter,
  setExcelData,
  setValidationErrors,
  setTableData,
  setIsExcelValid,
  setActiveStep,
  updateRowData,
  setDuplicateTableData,
  deleteRow,
  updateRowStatus,
  deleteInvalid,
  setInvalidData,
  resetImportState,
  setDuplicateRows,
  startImport,
  updateDuplicateRow,
  setIndividualData,
  handlePriceReset,
} = PriceSlice.actions;
export default PriceSlice.reducer;
